import React, { useEffect, useState } from "react";
import { FaAngleLeft, FaMinus, FaPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PRIVATE_API } from "../../../api/apiIndex";
import {
  createExam,
  getCreateExamsError,
  getCreateExamsStatus,
  setCreateExamIdleStatus,
} from "../../../redux/slice/examsSlice";
import { getTopics } from "../../../redux/slice/topicSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";

// const data = [
//   {
//     id: 1,
//     name: "Math",
//     Easy: {
//       1: {
//         size: 0,
//         count: 2,
//       },
//       2: {
//         size: 0,
//         count: 2,
//       },
//     },
//     Medium: {
//       1: {
//         size: 0,
//         count: 2,
//       },
//       2: {
//         size: 0,
//         count: 2,
//       },
//     },
//     Hard: {
//       1: {
//         size: 0,
//         count: 2,
//       },
//       2: {
//         size: 0,
//         count: 2,
//       },
//     },
//     count: {
//       1: 0,
//       2: 0,
//     },
//     total: {
//       1: 0,
//       2: 0,
//     },
//     grandTotal: 0,
//   },
// ];

const CreateExamForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const topics = useSelector(getTopics);

  const status = useSelector(getCreateExamsStatus);
  const error = useSelector(getCreateExamsError);

  const [topicName, setTopicName] = useState("");
  const [topicNameError, setTopicNameError] = useState("");

  const [startDate, setStartDate] = useState("");
  const [startDateError, setStartDateError] = useState("");

  const [subjectData, setSubjectData] = useState("");
  const [subjectDataError, setSubjectDataError] = useState("");

  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (topicName) {
      const details = topics.find((topic) => topic.topicName === topicName);
      PRIVATE_API.get(`/question/count-by-subject/${details._id}`).then(
        (res) => {
          setSubjectData(res.data.data);
          console.log(res.data.data);
        }
      );
      // setSubjectDataError("");
    }
  }, [topicName, topics]);

  const handleCreateExam = async (e) => {
    e.preventDefault();
    const _fromDate = new Date(startDate);
    let err = false;
    if (!topicName) {
      setTopicNameError("Topic name is required");
      err = true;
    }
    if (!startDate) {
      err = true;
      setStartDateError("Select a date");
    } else if (_fromDate.getDay() !== 0) {
      setStartDateError("Start day must be sunday");
      err = true;
    }

    if (total === 0) {
      setSubjectDataError("Select at least one question");
      err = true;
    }

    if (!err) {
      const _toDate = new Date(startDate);

      _fromDate.setHours(0, 0, 0, 0);
      _toDate.setHours(23, 59, 59, 59);
      _toDate.setDate(_fromDate.getDate() + 6);

      const fromDate = _fromDate.toISOString();
      const toDate = _toDate.toISOString();

      const data = { topicName, fromDate, toDate, subjectData };
      await dispatch(createExam(data)).unwrap();
      setStartDate("");
      setTopicName("");
    }
  };

  const handleIncrease = ({ id, marks, level, size, count }) => {
    // console.log(id, marks, level);
    if (count > size) {
      setSubjectData((prev) =>
        prev.map((entry) =>
          entry.id === id
            ? {
                ...entry,
                grandTotal: entry.grandTotal + marks,
                count: {
                  ...entry.count,
                  [marks]: entry.count[marks] + 1,
                },
                total: {
                  ...entry.total,
                  [marks]: entry.total[marks] + marks,
                },
                [level]: {
                  ...entry[level],
                  [marks]: {
                    ...entry[level][marks],
                    size: entry[level][marks].size + 1,
                  },
                },
              }
            : entry
        )
      );
      setTotal((prev) => prev + marks);
      setSubjectDataError("");
    }
  };
  const handleDecrease = ({ id, marks, level, size }) => {
    if (size > 0) {
      setSubjectData((prev) =>
        prev.map((entry) =>
          entry.id === id
            ? {
                ...entry,
                grandTotal: entry.grandTotal - marks,
                count: {
                  ...entry.count,
                  [marks]: entry.count[marks] - 1,
                },
                total: {
                  ...entry.total,
                  [marks]: entry.total[marks] - marks,
                },
                [level]: {
                  ...entry[level],
                  [marks]: {
                    ...entry[level][marks],
                    size: entry[level][marks].size - 1,
                  },
                },
              }
            : entry
        )
      );
      setTotal((prev) => prev - marks);

      setSubjectDataError("");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleData = ({ id, marks, level, value }) => {
    if (value && value >= 0) {
      const valueInt = parseInt(value);
      setSubjectData((prev) =>
        prev.map((entry) => {
          if (entry.id === id) {
            setTotal(
              entry.grandTotal -
                entry[level][marks].size * marks +
                valueInt * marks
            );
            return {
              ...entry,
              grandTotal:
                entry.grandTotal -
                entry[level][marks].size * marks +
                valueInt * marks,
              count: {
                ...entry.count,
                [marks]:
                  entry.count[marks] - entry[level][marks].size + valueInt * 1,
              },
              total: {
                ...entry.total,
                [marks]:
                  entry.total[marks] -
                  entry[level][marks].size * marks +
                  valueInt * marks,
              },
              [level]: {
                ...entry[level],
                [marks]: { ...entry[level][marks], size: valueInt },
              },
            };
          } else {
            return entry;
          }
        })
      );
    }
  };

  return (
    <section className="flex flex-col w-full sm:gap-12 gap-6">
      {status === "loading" ? <Loading /> : null}
      {status === "success" ? (
        <AlertBox
          type="success"
          message="Exam created successfully"
          toDispatch={setCreateExamIdleStatus}
        />
      ) : null}
      {status === "failed" ? (
        <AlertBox
          type="failed"
          message={error}
          toDispatch={setCreateExamIdleStatus}
        />
      ) : null}

      <div className="flex w-full justify-between items-center">
        <h1 className="text-[24px] font-semibold text-adminTextSecondary">
          Create an Exam
        </h1>
      </div>
      <div className="bg-primary flex flex-col gap-10 w-full sm:p-7 p-3 rounded-[4px] border border-adminMainBorder">
        <button
          type="button"
          onClick={handleBack}
          className="w-14 flex flex-row gap-2 items-center"
        >
          <FaAngleLeft />
          <span>Back</span>
        </button>
        <form
          onSubmit={handleCreateExam}
          className="flex flex-col gap-4 sm:px-4 p-0"
        >
          <div className="flex sm:flex-row flex-col justify-between items-start gap-4">
            {/* Topic name with error container */}
            <div className="flex flex-col gap-1 items-start w-full">
              {/* Topic name container */}
              <label
                htmlFor="topicName"
                className="font-semibold tracking-wide text-textPrimary"
              >
                Topic:
              </label>
              <select
                name="topicName"
                id="topicName"
                value={topicName}
                className="admin-input-box text-textSecondary w-full"
                onChange={(e) => {
                  setTopicName(e.target.value);
                  setTopicNameError("");
                  setSubjectData([]);
                }}
              >
                <option value="" className="text-textSecondary">
                  Select a topic
                </option>
                {topics?.map((entry) => (
                  <option
                    key={entry._id}
                    value={entry.topicName}
                    className="text-textSecondary"
                  >
                    {entry.topicName}
                  </option>
                ))}
              </select>
              <span className="pl-4 text-[12px] italic text-red-500">
                {topicNameError}
              </span>
            </div>

            {/* Date with error container */}
            <div className="flex flex-col gap-1 items-start w-full">
              {/* Date container */}
              <label
                htmlFor="date"
                className="font-semibold tracking-wide text-textPrimary"
              >
                Start Date:
              </label>
              <input
                type="date"
                name="date"
                id="date"
                value={startDate}
                className="admin-input-box text-textSecondary w-full"
                onChange={(e) => {
                  setStartDate(e.target.value);
                  setStartDateError("");
                }}
              />
              <span className="pl-4 text-[12px] italic text-red-500">
                {startDateError}
              </span>
            </div>
          </div>

          {/* Subjects and question count container */}
          <div className="flex flex-col justify-between items-start gap-1 w-full">
            {/* Subjects container */}
            <span className="font-semibold tracking-wide text-textPrimary">
              Subject wise question count:
            </span>
            {!topicName ? (
              <p className="italic text-red-500 text-sm">Select a topic</p>
            ) : subjectData.length === 0 ? (
              <p className="italic text-red-500 text-sm">
                No question for selected topic
              </p>
            ) : (
              <div className="sm:w-full w-[calc(100vw-120px)] overflow-x-auto">
                <table className="w-full border border-textSecondary text-center">
                  <thead className="border border-textSecondary">
                    <tr className="border border-textSecondary">
                      <th
                        className="border border-textSecondary px-4 py-2"
                        rowSpan={2}
                      >
                        Subject
                      </th>
                      <th
                        className="border border-textSecondary px-4 py-2"
                        rowSpan={2}
                      >
                        Marks
                      </th>
                      <th
                        className="border border-textSecondary px-4 py-2"
                        colSpan={3}
                      >
                        Level
                      </th>
                      <th
                        className="border border-textSecondary px-4 py-2"
                        colSpan={2}
                      >
                        Total
                      </th>
                      <th
                        className="border border-textSecondary px-4 py-2"
                        rowSpan={2}
                      >
                        Grand Total
                      </th>
                    </tr>
                    <tr className="border border-textSecondary">
                      <th className="border border-textSecondary px-4 py-2">
                        Easy
                      </th>
                      <th className="border border-textSecondary px-4 py-2">
                        Medium
                      </th>
                      <th className="border border-textSecondary px-4 py-2">
                        Hard
                      </th>
                      <th className="border border-textSecondary px-4 py-2">
                        Count
                      </th>
                      <th className="border border-textSecondary px-4 py-2">
                        Marks
                      </th>
                    </tr>
                  </thead>
                  <tbody className="border border-textSecondary">
                    {/* Subject section */}
                    {subjectData.map((subject, key) => (
                      <>
                        <tr className="border border-textSecondary">
                          <th
                            className="border border-textSecondary px-4 py-2"
                            rowSpan={2}
                          >
                            {subject.name}
                          </th>
                          {/* 1 marks */}
                          <td className="border border-textSecondary px-4 py-2">
                            1
                          </td>

                          {/* 1 marks Easy */}
                          <td className="border border-textSecondary px-4 py-2 ">
                            {subject.Easy?.[1] ? (
                              <div className="flex">
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleDecrease({
                                      id: subject.id,
                                      marks: 1,
                                      level: "Easy",
                                      size: subject.Easy[1].size,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaMinus className="text-[12px]" />
                                </button>
                                <input
                                  type="number"
                                  // id={entry._id}
                                  name="number"
                                  value={subject.Easy[1].size}
                                  onChange={(e) =>
                                    handleData({
                                      value: e.target.value,
                                      id: subject.id,
                                      marks: 1,
                                      level: "Easy",
                                    })
                                  }
                                  min="0"
                                  max={subject.Easy[1].count}
                                  className="text-center focus:outline-none text-textSecondary w-full"
                                />
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleIncrease({
                                      id: subject.id,
                                      marks: 1,
                                      level: "Easy",
                                      size: subject.Easy[1].size,
                                      count: subject.Easy[1].count,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaPlus className="text-[12px]" />
                                </button>
                              </div>
                            ) : (
                              "NA"
                            )}
                          </td>

                          {/* 1 marks medium */}
                          <td className="border border-textSecondary px-4 py-2 ">
                            {subject.Medium?.[1] ? (
                              <div className="flex">
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleDecrease({
                                      id: subject.id,
                                      marks: 1,
                                      level: "Medium",
                                      size: subject.Medium[1].size,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaMinus className="text-[12px]" />
                                </button>
                                <input
                                  type="number"
                                  // id={entry._id}
                                  name="number"
                                  value={subject.Medium[1].size}
                                  onChange={(e) =>
                                    handleData({
                                      value: e.target.value,
                                      id: subject.id,
                                      marks: 1,
                                      level: "Medium",
                                    })
                                  }
                                  min="0"
                                  max={subject.Medium[1].count}
                                  className="text-center focus:outline-none text-textSecondary w-full"
                                />
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleIncrease({
                                      id: subject.id,
                                      marks: 1,
                                      level: "Medium",
                                      size: subject.Medium[1].size,
                                      count: subject.Medium[1].count,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaPlus className="text-[12px]" />
                                </button>
                              </div>
                            ) : (
                              "NA"
                            )}
                          </td>

                          {/* 1 marks hard */}
                          <td className="border border-textSecondary px-4 py-2 ">
                            {subject.Hard?.[1] ? (
                              <div className="flex">
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleDecrease({
                                      id: subject.id,
                                      marks: 1,
                                      level: "Hard",
                                      size: subject.Hard[1].size,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaMinus className="text-[12px]" />
                                </button>
                                <input
                                  type="number"
                                  // id={entry._id}
                                  name="number"
                                  value={subject.Hard[1].size}
                                  onChange={(e) =>
                                    handleData({
                                      value: e.target.value,
                                      id: subject.id,
                                      marks: 1,
                                      level: "Hard",
                                    })
                                  }
                                  min="0"
                                  max={subject.Hard[1].count}
                                  className="text-center focus:outline-none text-textSecondary w-full"
                                />
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleIncrease({
                                      id: subject.id,
                                      marks: 1,
                                      level: "Hard",
                                      size: subject.Hard[1].size,
                                      count: subject.Hard[1].count,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaPlus className="text-[12px]" />
                                </button>
                              </div>
                            ) : (
                              "NA"
                            )}
                          </td>
                          <td className="border border-textSecondary px-4 py-2">
                            {subject.count?.[1]}
                          </td>
                          <td className="border border-textSecondary px-4 py-2">
                            {subject.total?.[1]}
                          </td>
                          <td
                            className="border border-textSecondary px-4 py-2"
                            rowSpan={2}
                          >
                            {subject.grandTotal}
                          </td>
                        </tr>

                        {/* 2 marks */}
                        <tr className="border border-textSecondary">
                          {/* 2marks Easy */}
                          <td className="border border-textSecondary px-4 py-2">
                            2
                          </td>
                          <td className="border border-textSecondary px-4 py-2 ">
                            {subject.Easy?.[2] ? (
                              <div className="flex">
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleDecrease({
                                      id: subject.id,
                                      marks: 2,
                                      level: "Easy",
                                      size: subject.Easy[2].size,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaMinus className="text-[12px]" />
                                </button>
                                <input
                                  type="number"
                                  // id={entry._id}
                                  name="number"
                                  value={subject.Easy[2].size}
                                  onChange={(e) =>
                                    handleData({
                                      value: e.target.value,
                                      id: subject.id,
                                      marks: 2,
                                      level: "Easy",
                                    })
                                  }
                                  min="0"
                                  max={subject.Easy[2].count}
                                  className="text-center focus:outline-none text-textSecondary w-full"
                                />
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleIncrease({
                                      id: subject.id,
                                      marks: 2,
                                      level: "Easy",
                                      size: subject.Easy[2].size,
                                      count: subject.Easy[2].count,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaPlus className="text-[12px]" />
                                </button>
                              </div>
                            ) : (
                              "NA"
                            )}
                          </td>

                          {/* 2 marks medium */}
                          <td className="border border-textSecondary px-4 py-2 ">
                            {subject.Medium?.[2] ? (
                              <div className="flex">
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleDecrease({
                                      id: subject.id,
                                      marks: 2,
                                      level: "Medium",
                                      size: subject.Medium[2].size,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaMinus className="text-[12px]" />
                                </button>
                                <input
                                  type="number"
                                  // id={entry._id}
                                  name="number"
                                  value={subject.Medium[2].size}
                                  onChange={(e) =>
                                    handleData({
                                      value: e.target.value,
                                      id: subject.id,
                                      marks: 2,
                                      level: "Medium",
                                    })
                                  }
                                  min="0"
                                  max={subject.Medium[2].count}
                                  className="text-center focus:outline-none text-textSecondary w-full"
                                />
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleIncrease({
                                      id: subject.id,
                                      marks: 2,
                                      level: "Medium",
                                      size: subject.Medium[2].size,
                                      count: subject.Medium[2].count,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaPlus className="text-[12px]" />
                                </button>
                              </div>
                            ) : (
                              "NA"
                            )}
                          </td>

                          {/* 2 marks hard */}
                          <td className="border border-textSecondary px-4 py-2 ">
                            {subject.Hard?.[2] ? (
                              <div className="flex">
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleDecrease({
                                      id: subject.id,
                                      marks: 2,
                                      level: "Hard",
                                      size: subject.Hard[2].size,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaMinus className="text-[12px]" />
                                </button>
                                <input
                                  type="number"
                                  // id={entry._id}
                                  name="number"
                                  value={subject.Hard[2].size}
                                  onChange={(e) =>
                                    handleData({
                                      value: e.target.value,
                                      id: subject.id,
                                      marks: 2,
                                      level: "Hard",
                                    })
                                  }
                                  min="0"
                                  max={subject.Hard[2].count}
                                  className="text-center focus:outline-none text-textSecondary w-full"
                                />
                                <button
                                  type="button"
                                  tabIndex={-1}
                                  onClick={() =>
                                    handleIncrease({
                                      id: subject.id,
                                      marks: 2,
                                      level: "Hard",
                                      size: subject.Hard[2].size,
                                      count: subject.Hard[2].count,
                                    })
                                  }
                                  className="px-3 text-textPrimary rounded-full"
                                >
                                  <FaPlus className="text-[12px]" />
                                </button>
                              </div>
                            ) : (
                              "NA"
                            )}
                          </td>
                          <td className="border border-textSecondary px-4 py-2">
                            {subject.count?.[2]}
                          </td>
                          <td className="border border-textSecondary px-4 py-2">
                            {subject.total?.[2]}
                          </td>
                        </tr>
                      </>
                    ))}

                    {/* Bottom total Section */}
                    <tr className="border border-textSecondary">
                      <th
                        className="border border-textSecondary px-4 py-2"
                        colSpan={7}
                      >
                        Total
                      </th>

                      <td className="border border-textSecondary px-4 py-2">
                        {total}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            <span className="pl-4 text-[12px] italic text-red-500">
              {subjectDataError}
            </span>
          </div>

          <div className="self-end">
            <button
              type="submit"
              className="text-white bg-adminRightTextPrimary h-[32px] px-4 text-sm rounded-[4px] flex flex-row items-center justify-center gap-2"
            >
              <FaPlus />
              <span>Create Exam</span>
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default CreateExamForm;
